import React, { Component } from 'react';
import Tumbler from './Tumbler';
import DateFilter from './DateFilter';
import StatusFilter from './StatusFilter';

var Filter = React.createClass({
  handlerOpenOrCloseFilter: function () {
    var data = { ...this.props.data };
    data.open = !data.open;
    this.props.actionDataFilter(data);
  },
  handlerChange: function (data, type) {
    var obj = { ...this.props.data };
    obj[type] = data;
    if(data === false){
      obj[type + 'Data'].select = false
    }
    this.props.actionFilter(function(){return true}, type);
    this.props.actionDataFilter(obj);
  },
  actionFilter: function(data, type){
    this.props.actionFilter(data, type);
  },
  actionDataFilter: function(data, type){
    this.props.actionDataFilter(data);
  },
  handlerSearchFunc: function(a, b){
    var fields = [
          'firstName',
          'middleName',
          'secondtName',
          'numberPhone',
          'EMail',
          'city'
        ],
        textFields = '',
        reg = new RegExp(b.search, 'gimu');

    if(b.search == '') return true;

    for(var i = 0, l = fields.length; i < l; i++){
      textFields += a[fields[i]];
    }

    if(a.numberPhone){
      textFields += a.numberPhone.replace(/ /g, '');
    }

    // console.log(textFields);

    if(reg.test(textFields)){
      return true
    }

    return false;
  },
  handlerSearch: function(el){
    var value = el.target.value,
        obj = { ...this.props.data2 };

    if(typeof obj.filter.search != 'function'){
      obj.filter.search = this.handlerSearchFunc;
    }

    obj.dataFilter.search = value;
    this.props.actionFil(obj);
  },
  handlerTestKey: function(event){
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!/^[a-zA-Z]| |[а-яА-Я]|[0-9]+$/.test(key)) {
        event.preventDefault();
        return false;
    }
  },
  handlerClear: function(){

  },
  render: function(){
    if(!this.props.data.open){
        return(<div className="SelectSpecialtiesOpen" onClick={this.handlerOpenOrCloseFilter}>Фильтр</div>)
    }else{
      return(
        <div className="UserList">
          <div className="User Filter">
            <div className="filter">
              <div className="name">Группировка по датам:</div>
              <Tumbler changer={this.handlerChange} open={this.props.data.date} type="date" />
              {this.props.data.date ? <DateFilter data={this.props.data} actionDataFilter={this.actionDataFilter} actionFilter={this.actionFilter} /> : ''}
            </div>
            <div className="filter">
              <div className="name">Группировка по статусу:</div>
              <Tumbler changer={this.handlerChange} open={this.props.data.status} type="status" />
              {this.props.data.status ? <StatusFilter data={this.props.data} actionDataFilter={this.actionDataFilter}  actionFilter={this.actionFilter} /> : ''}
            </div>
            <div className="filter noTumbler">
              <div className="name">Поиск по всем полям:</div>
              <input type="text" onKeyPress={this.handlerTestKey} onChange={this.handlerSearch} onBlur={this.handlerBlur} value={this.props.data.search} />
            </div>
          </div>
        </div>
      )
    }
  }
});

export default Filter;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Filter/index.jsx
 **/